export default "__VITE_ASSET__39c95b1e__"